/* React */
import React from "react";

/* Ionic */
import { IonItem, IonIcon } from "@ionic/react";
import {
  ellipseOutline,
  radioButtonOn,
} from "ionicons/icons";

/* React-Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { toggleCohortSelection } from "src/redux/features/custom-cohorts/customCohortsSlice";

/* Stylesheet */
import styles from "./CohortDropdown.module.scss";

const CohortDropdown: React.FC = () => {
  const dispatch = useDispatch();

  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );
  const { currentDiseaseId, customCohortsByDisease } =
    customCohortsState;

  const handleToggleSelection = (id: string) => {
    dispatch(toggleCohortSelection(id));
  };

  const cohorts = currentDiseaseId
    ? customCohortsByDisease[currentDiseaseId]?.cohorts ??
      []
    : [];

  return (
    <>
      {cohorts.map((item, index) => {
        const checked = item.show;

        return (
          <IonItem
            key={index}
            className={styles.dropdown_item}
            lines="none"
            button
            onClick={() => handleToggleSelection(item.id)}
          >
            <IonIcon
              className={styles.icon}
              icon={
                checked ? radioButtonOn : ellipseOutline
              }
            />
            <div className={styles.label}>{item.name}</div>
          </IonItem>
        );
      })}
    </>
  );
};

export default CohortDropdown;
